export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_35-be79caf0623a8358aebe9b2cc091cb24.jpg";